import { useContext, useRef } from 'react'
// import { ToDoListAdminProvider } from './ToDoListAdminProvider'
import { Clipboard2, ExclamationDiamondFill } from 'react-bootstrap-icons'
import CommonFunctionsContext from '../../../../common/CommonFunctionsProvider'
import { ToDoListAdminContext } from '../ToDoListAdmin'
import TitleBarComponent from './TitleBarComponent'
import ToggleContainerComponent from './ToggleContainerComponent'

export default function ToDoListLineItem({ group, children, collapsed, onRemove, onEdit }) {
    const { showConfirm, showError } = useContext(CommonFunctionsContext)
    const { validateToDoList, cloneToDoList } = useContext(ToDoListAdminContext)
    const CloneNameRef = useRef()

    const _handleClone = async (e) => {
        if (e) {
            e.stopPropagation()
        }
        showConfirm({
            onCancel: () => { },
            onConfirm: (a) => {
                if (!CloneNameRef.current.value || CloneNameRef.current.value === '') {
                    CloneNameRef.current.placeholder = 'Please enter a name to clone to'
                    CloneNameRef.current.style = 'border: solid red 2px'
                    return false
                }
                cloneToDoList({
                    id: group.resource.id,
                    name: CloneNameRef.current.value
                })
                    .then(res => { return true })
                    .catch(err => showError(err))
            }
            ,
            title: () => { },
            heading: "Clone : New Name",
            children: <div>
                <p>Please enter a name you would like to clone this list to</p>
                <input
                    ref={CloneNameRef}
                    className='form-control' placeholder='New name' />
            </div>,
            // type: () => { },
            options: {
                cancel: 'Cancel',
                confirm: 'Clone'
            }
        })
    }

    return (<ToggleContainerComponent
        id={group.resource.id}
        focused={{
            group: group.resource.id,
            item: undefined,
            status: undefined,
            properties: undefined
        }}
        open={collapsed ? collapsed : false}
        className='bg-primary-container shadow rounded'
        header={<TitleBarComponent
            cloneable={{
                action: _handleClone
            }}
            container={<div className='m-1'>
                <div>
                    <Clipboard2 className='me-2' />{group.resource.group}</div>
                {
                    validateToDoList(group.resource.id) && <div className='bg-warning-container text-start p-1 rounded small'>
                        <ExclamationDiamondFill className='me-2' />{validateToDoList(group.resource.id)}</div>
                }
            </div>}
            title={group.resource.group} onRemove={onRemove} onEdit={onEdit} />}>
        <div className='bg-secondary-container m-2 rounded'>
            {children}
        </div>
    </ToggleContainerComponent >)
}